import React, { useState } from 'react';
import Loader from './Loader/Loader.js';

export const IsLoadingHOC = (WrappedComponent, loadingMessage) => {
    function HOC(props) {
        const [isLoading, setLoading] = useState(true);
        const setLoadingState = isComponentLoading => {
            setLoading(isComponentLoading);
        };
        return (
            <>
            {isLoading && <Loader message={loadingMessage} />}
            <WrappedComponent { ...props} setLoading={setLoadingState} />
            </>
        );
    }
    return HOC;
};

export default IsLoadingHOC;

// This extends the Loader.js component as a universal higher order component
// import the IsLoadingHOC component to the component you want to WrappedComponent

// pass props setLoading and include useEffect as per below example:

// function Login(props) {
//     const [email, setEmail] = useState("");
//     const [password, setPassword] = useState("");
//     const { setLoading } = props;
  
//     useEffect(() => {
//       setLoading(false);
//     }, []);

//     then you can control where you setLoading true or false. e.g:

//     const signIn = () => {
//         // Google Login
//         setLoading(true);
//         auth.signInWithPopup(provider).catch((error) => alert(error.message));
       
//       };

//     At the end of the function wrap component e.g.:

//     export default IsLoadingHOC(Login, 'Loading...');
